/**
 * @file Header.
 */

/**
 * Header component.
 */
const vHeader = () => {
	const header = document.querySelector('.v-header');

	if (!header) {
		return;
	}

	const navTrigger = header.querySelector('.v-header__nav-trigger');
	navTrigger.addEventListener('click', () => {
		const event = new CustomEvent('v-mobile-nav-toggle', { detail: { open: true } });
		document.dispatchEvent(event);
	});
};

export default vHeader;
